<template>
  <div
    class="popular-leagues"
    :class="{ 'open-popular-leagues': open }"
  >
    <active-button
      class="popular-leagues-hat gold-color"
      @click="open = !open"
    >
      <span class="caption">{{ $t('popular-tournaments') }}</span>
      <arrow-icon color="gold" :direction="open ? 'up' : 'down'" />
    </active-button>
    <div class="popular-leagues-list">
      <active-button
        class="popular-league flex"
        v-for="league in leagues"
        :key="league.id"
        line-color="blue"
        line-position="left"
        :active="parseInt($route.params.sport) === league.sport && parseInt($route.params.league) === league.id"
        @click="$router.push(`/prematch/sport/${league.sport}/league/${league.id}`)"
      >
        <div class="sport-icon-box">
          <sport-icon-liga-white :name="league.alias" />
        </div>
        <div
          class="league-name ellipsis"
          :title="league.name"
        >
          {{ league.name }}
        </div>
      </active-button>
    </div>
  </div>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import ArrowIcon from '@/components/icons/ArrowIcon'
import SportIconLigaWhite from '@/components/icons/SportIconLigaWhite'
import { mapState } from 'vuex'

export default {
  components: { ActiveButton, ArrowIcon, SportIconLigaWhite },
  computed: {
    ...mapState({
      leagues: state => state.prematch.popular.leagues
    })
  },
  data () {
    return {
      open: false
    }
  }
}
</script>

<style scoped>
.popular-leagues { width: 225px; }
.popular-leagues-hat { display: flex; line-height: 40px; padding-left: 10px; }
.popular-leagues-hat .caption { flex: 1; }
.popular-leagues-list { display: none; }
.open-popular-leagues .popular-leagues-list { display: block; }
.popular-league { height: 40px; line-height: 40px; padding-right: 10px; }
.popular-league .sport-icon { margin: 12px; }
</style>

<style>
.left-sidebar-layout.compact .popular-leagues { display: none; }
</style>

<style>
.sport-icon-box { margin: 6px; margin-right: 2px; }
</style>



// WEBPACK FOOTER //
// src/components/sports/menu/Popular.vue